import React from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'

import { ClientUserDetailTable } from 'src/components/Table/detail/ClientUser'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  clientGuid: string
  guid: string
}

export const ClientUserPage = () => {
  const { clientGuid, guid } = useParams<PathProps>()

  const user = useQuery(['supply-chain-details'], () =>
    skuit.sc.clients.users.retrieve(clientGuid, guid)
  )

  const refresh = () => {
    user.refetch()
  }

  return (
    <>
      <DetailPage
        obj={user}
        title="Supply Chain User"
        refresh={refresh}
        breadcrumbs={[
          { title: 'Dashboard', url: '/' },
          { title: 'Clients', url: '/clients' },
        ]}
        detailComponent={<ClientUserDetailTable obj={user} refresh={refresh} clientGuid={clientGuid} />}
      ></DetailPage>
    </>
  )
}
